'use client';
import { FC, useCallback, useEffect, useRef, useState } from 'react';

import { CheckIconXs } from '@lichtblick/icons/svg/check/check-xs';
import { CopyIconXs } from '@lichtblick/icons/svg/copy/copy-xs';
import { TextCTA } from '@lichtblick/photon/atoms/text-cta/text-cta';

export const CopyButton: FC<{ text: string }> = ({ text }) => {
  const [copied, setCopied] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | undefined>(undefined);

  useEffect(() => {
    timeoutRef.current = setTimeout(() => {
      setCopied(false);
    }, 2500);

    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, [copied, setCopied]);

  const clickHandler = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(text ?? '');
      setCopied(true);
    } catch (error) {
      // bad luck
    }
  }, [text]);

  return (
    <TextCTA
      ariaLabel="Bonuscode kopieren"
      as="button"
      icon={copied ? <CheckIconXs /> : <CopyIconXs />}
      onClick={clickHandler}
      type="button"
    />
  );
};
